import { Col, Row } from 'react-bootstrap';
import RadioInput from '../common/radio';
import CheckboxInput from 'src/Member/components/common/checkbox';

const EligiblePersonas = ({ values, setFieldValue }) => {
  return (
    <Row className="Payment-details section-separator-border">
      <Col md={5} lg={5} sm={5} className="padding-0">
        <h3>Eligible Persona(s)</h3>
        <p>Select the Persona(s) who can use the self-unlock feature. </p>
      </Col>
      <Col md={2} lg={2} sm={2} className="setup-form">
        <Row className="pt-2">
          <Col>
            <CheckboxInput
              inline
              name="MemberEligiblePersonas"
              label={'Member'}
              value={'allowMember'}
              className="cursor-pointer d-none"
              onChange={(e) =>
                setFieldValue('MemberEligiblePersonas', e.target.checked)
              }
              checked={values.MemberEligiblePersonas === true}
            />
          </Col>
          <Col>
            <CheckboxInput
              inline
              name="DependentEligiblePersonas"
              label={'Dependent'}
              value={'allowDependent'}
              className="cursor-pointer d-none"
              onChange={(e) =>
                setFieldValue('DependentEligiblePersonas', e.target.checked)
              }
              checked={values.DependentEligiblePersonas === true}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default EligiblePersonas;
